<template>
  <v-expansion-panel expand>
    <v-expansion-panel-content lazy v-for="breakdownInfo in breakdownInfos" :key="breakdownInfo.id"
                               :value="breakdownInfo.isOpen"
                               class="expansion-panel-custom" v-on:input="setFeedBreakdownState(breakdownInfo.id)">
      <div slot="header" class="prevent-overflow break-module">
        <FeedRequestBreakdownInfoHeader :breakdownInfo="breakdownInfo"
                                        :open="breakdownInfo.isOpen"/>
      </div>
      <FeedRequestBreakdownInfoBody :breakdownInfo="breakdownInfo" :open="breakdownInfo.isOpen"/>
    </v-expansion-panel-content>
    <div v-if="breakdownInfos.length === 0" class="info info-text info-message">
      {{$t('feeds.feed_breakdown_empty_list')}}
    </div>
  </v-expansion-panel>
</template>

<script>
  import DateFormat from '../../mixins/DateFormat'
  import {
    GET_AUDIT_BREAKDOWN_INFO, GET_FEED_BREAKDOWN_INFO, STORE_FEED_BREAKDOWN_AUDIT_ID
  } from '../../store/action-types'

  import {mapActions, mapMutations, mapState} from 'vuex'
  import FeedRequestBreakdownInfoHeader from './FeedRequestBreakdownInfoHeader'
  import FeedRequestBreakdownInfoBody from './FeedRequestBreakdownInfoBody'
  import {SET_FEED_BREAKDOWN_LIST_SCROLL_TOP, SET_FEED_BREAKDOWN_SHOW_STATE} from '../../store/mutation-types'

  export default {
    name: 'feed-request-breakdown-info-row',
    mixins: [DateFormat],
    computed: {
      ...mapState({
        scheduleId: state => state.feeds.scheduleId,
        breakdownInfos: state => state.feeds.breakdownInfos,
        totalElements: state => state.feeds.totalElements,
        last: state => state.feeds.lastPage,
        loading: state => state.feeds.isLoading,
        scrollTop: state => state.feeds.scrollTop
      })
    },
    data () {
      return {}
    },
    methods: {
      ...mapActions({
        getBreakDownInfo: GET_FEED_BREAKDOWN_INFO,
        getAuditBreakdownInfo: GET_AUDIT_BREAKDOWN_INFO,
        setRequestId: STORE_FEED_BREAKDOWN_AUDIT_ID
      }),
      ...mapMutations({
        updateScrollTop: SET_FEED_BREAKDOWN_LIST_SCROLL_TOP
      }),
      refreshTableOnScroll () {
        this.getBreakDownInfo()
      },
      setFeedBreakdownState (value) {
        this.$store.commit(SET_FEED_BREAKDOWN_SHOW_STATE, value)
      }
    },
    components: {
      FeedRequestBreakdownInfoHeader,
      FeedRequestBreakdownInfoBody,
      DateFormat
    }

  }
</script>

<style scoped>
  .info-message {
    padding: 1em;
    text-align: center;
    width: 100%;
  }

  .expansion-panel-custom {
    border-bottom: 1px solid #ededed;
  }

  .expansion-panel__container:hover {
    background-color: #E0E0E0;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/FeedRequestBreakdownInfoRow.vue